import { render, staticRenderFns } from "./splitAndCrop.vue?vue&type=template&id=2748a8d2&scoped=true&"
import script from "./splitAndCrop.vue?vue&type=script&lang=js&"
export * from "./splitAndCrop.vue?vue&type=script&lang=js&"
import style0 from "./splitAndCrop.vue?vue&type=style&index=0&id=2748a8d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2748a8d2",
  null
  
)

export default component.exports